import { atom } from "recoil";

export const activeConnectorIdState = atom({
  key: "activeConnectorIdState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
